import * as _ from 'lodash';
import { FormatterEx } from 'slickgrid';
import { humanFileSize } from '../helpers';

const DEFAULTS = {
  si: false,
};

export interface FilesizeFormatterOptions {
  si?: boolean;
}

export function filesize<T>(opts: FilesizeFormatterOptions): FormatterEx<T> {
  const si = opts.si;

  const fn: FormatterEx<T> = function filesizeFormatter(
    row,
    cell,
    value,
    columnDef,
    data,
  ) {
    return value == null ? '' : humanFileSize(value, si);
  };

  fn.filterFormattedData = true;
  return fn;
}
